import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import CommunicationDetails from "../../../PreAuth/components/CommunicationDetails";
import JsonTable from "../../../PreAuth/components/response/JsonTable";
import gqlPreAuth from "../../../../gql/preAuth";
import Encounter from "../../../PreAuth/components/response/Encounter";
import AccidentInfo from "../../../PreAuth/components/response/AccidentInfo";
import VisionPrescription from "../../../PreAuth/components/response/VisionPrescription";
import "../../../PreAuth/styles/pre-auth.css";
import UcafForm from "../../../Claims/components/ucaf/UcafForm";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Button, Tooltip } from "@mui/material";
import DcafForm from "../../../Claims/components/ucaf/DcafForm";
import ItemRejectReason from "../../../PreAuth/components/response/ItemRejectReason";
import CareTeamsTable from "../../../PreAuth/components/response/CareTeamsTable";
import ItemsTable from "./ItemsTable";
import DiagnosisTable from "../../../PreAuth/components/response/DiagnosisTable";
import SupportingInfoTable from "../../../PreAuth/components/response/SupportingInfoTable";
import ResponseDetailsComponentNew from "./ResponseDetailsComponentNew";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    minHeight: "95vh",
    minWidth: "85%",
    maxHeight: "75vh",
    overflowY: "scroll",
    paddingTop: "0 !important",
  },
};

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

let subtitle;
const PreAuthDetailComponent = ({ detailsData }) => {
  const currentDate = new Date();
  const navigate = useNavigate();
  const location = useLocation();

  const currentItem = location.state?.currentItem
    ? location.state.currentItem
    : null;
  const { id } = useParams();

  const [showUCAF, setShowUCAF] = useState(false);
  const [showDCAF, setShowDCAF] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [showItems, setShowItems] = useState(false);
  const [myFirstName, setmyFirstName] = useState(false);
  const [showInfoItem, setshowInfoItem] = useState(false);

  function afterOpenModal() {}

  const [currentTab, setCurrentTab] = useState("details");

  const tabs = [
    { label: "Details", value: "details" },
    { label: "Communications", value: "communications" },
    // { name: "JSON", href: "#", current: false },
    { label: "Encounter", value: "encounter" },
    { label: "Accident", value: "accident" },
    { label: "Vision Prescription", value: "visionPrescription" },
    { label: "Reject Reason", value: "rejectReason" },
  ];

  const types = [
    { id: 1, name: "HCP" },
    { id: 2, name: "Public HCP" },
  ];

  const tableHeaders = [
    { name: "Payer" },
    { name: "Expiry Date" },
    { name: "Member Card ID" },
    { name: "Policy Number" },
    { name: "Relation With Subscriber" },
  ];
  let firstName = "Payer";

  const [eligibilityResponseData, setEligibilityResponseData] = useState([
    {
      id: 1,
      InForce: "Yes",
      BenefitDate: "01/01/2023 - 31/12/2023",
      MemberId: 35444349,
      PolicyNumber: 22001814,
      Type: "Extended HealthCare",
      Status: true,
      RelationWithSubscriber: "self",
      SubscriberMemberId: "",
      Network: "0222",
      Subrogation: false,
      SiteEligibility: "eligible",
      visible: false,
    },
  ]);

  const preAuthItem = {
    payer: "XYZ",
    expiry_date: "23/3/2024",
    member_card_id: "12223",
    policy_number: "12223",
    relationShipWithSubscriber: "ssdd",
  };

  const [expanded, setExpanded] = React.useState("detail");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };
  const {
    loading: loadingSupportingInfo,
    error: errorSupportingInfo,
    data: detailsSupportingInfo,
    refetch: refetchSupportingInfo,
  } = useQuery(gqlPreAuth.GET_PREAUTH_TRANSACTION_DETAILS_SI, {
    variables: {
      transactionId: id,
    },
    skip: expanded !== "supportinginfo" || true,
  });

  const CustomTabs = (props) => (
    <Tabs
      {...props}
      sx={{
        "& .MuiTabs-indicator": {
          backgroundColor: "#0070C2", // Customize indicator color
        },
        "& .Mui-selected": {
          color: "#0070C2", // Customize text color for selected tab
        },
        "& .MuiTabs-flexContainer": {
          "& > *": {
            color: "black", // Set default text color to black
          },
        },
      }}
    />
  );

  const tabToActive = location?.state?.tabToActive;
  useEffect(() => {
    setCurrentTab(tabToActive || "details");
  }, []);

  return (
    <div class="pre_auth_detail_page relative">
      <div className="flex justify-between flex-col lg:flex-row gap-4 mb-0 px-3 pb-2 border-b border-b-gray-300">
        <div class="flex !gap-5 items-center justify-center">
          <div className="flex items-center gap-3 justify-center">
            <Tooltip
              placement="right"
              title="Keep track of your Pre-Authorization details"
              className=""
            >
              <span className="font-semibold text-black/70 text-lg ">
                <span className="text-base">
                  PreAuth:
                  <span className="font-medium text-[14px] ms-2">
                    {detailsData?.getPreAuthTransaction?.data?.transaction_id}
                  </span>
                </span>
              </span>
            </Tooltip>
            <div className=" text-[14px] font-medium rounded-md min-w-[100px]">
              <span className="font-semibold text-black/70 text-base">
                Request Bundle ID:
              </span>
              <span className=" !text-primary !font-[600] ml-1">
                {detailsData?.getPreAuthTransaction?.data?.request_bundle_id}
              </span>
            </div>
          </div>
        </div>

        {/* <div className='my-auto'>
          <div class=' flex gap-3 flex-col md:flex-row'>
            <Button
              variant='contained'
              size='small'
              onClick={() => {
                navigate(
                  `/preauth/edit/form/${detailsData?.getPreAuthTransaction?.data?.transaction_id}`
                )
              }}
              style={{
                backgroundImage:
                  'linear-gradient(83deg, #0070C2)'
              }}
              startIcon={<TbEditCircle />}
            >
              Edit Pre Auth
            </Button>
            <Button
              variant='contained'
              size='small'
              onClick={() =>
                detailsData?.getPreAuthTransaction?.data?.type === 'oral'
                  ? setShowDCAF(true)
                  : setShowUCAF(true)
              }
              style={{
                backgroundImage:
                  'linear-gradient(83deg, #0070C2)'
              }}
              startIcon={<AddIcon />}
            >
              {detailsData?.getPreAuthTransaction?.data?.type === 'oral'
                ? 'DCAF'
                : 'UCAF'}
            </Button>
            {detailsData?.getPreAuthTransaction?.data?.is_followup_req &&
            detailsData?.getPreAuthTransaction?.data?.status === 'rejected' ? (
              <Button
                variant='outlined'
                size='small'
                onClick={() => {
                  navigate(
                    `/preauth/edit/form/${
                      detailsData?.getPreAuthTransaction?.data?.transaction_id
                    }/${'follow-up'}`
                  )
                }}
                className='!border-primary !text-primary hover:!bg-primary/10'
                startIcon={<AddIcon />}
              >
                Follow Up
              </Button>
            ) : !detailsData?.getPreAuthTransaction?.data?.is_followup_req ? (
              <Button
                variant='outlined'
                size='small'
                onClick={() => {
                  navigate(
                    `/preauth/edit/form/${
                      detailsData?.getPreAuthTransaction?.data?.transaction_id
                    }/${'follow-up'}`
                  )
                }}
                className='!border-primary !text-primary hover:!bg-primary/10'
                startIcon={<AddIcon />}
              >
                Follow Up
              </Button>
            ) : null}
          </div>
        </div> */}
      </div>

      <div class="pre_auth_details_nav_menu !flex !justify-start flex-col lg:flex-row gap-8 w-full !mt-2 !mb-0 border-b border-gray-300">
        <div className="pre_auth_details_nav_menu_ border-0">
          <Box
            sx={{ maxWidth: { xs: 320, sm: 480, md: 720, lg: 980, xl: 1260 } }}
          >
            <CustomTabs
              value={currentTab}
              onChange={handleTabChange}
              textColor="inherit"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              aria-label="scrollable force tabs example"
              className="!min-w-[40px] !min-h-[auto] "
            >
              {tabs?.map((tab, i) => (
                <Tab
                  className="!pt-[5px] !pb-[8px] !px-[10px] !min-h-[auto]"
                  key={i}
                  value={tab.value}
                  label={tab.label}
                />
              ))}
            </CustomTabs>
          </Box>
        </div>
      </div>

      {currentTab == "details" && (
        <>
          {detailsData?.getPreAuthTransaction?.data?.errors?.map(
            (el, index) => {
              return (
                <div className="sm:col-span-6 mb-2">
                  <div class="px-3 py-6 text-sm text-red-800 rounded-lg bg-red-50 dark:text-red-400">
                    <span class="font-medium">Error {el?.error_code} : </span>
                    {el?.error_message}
                  </div>
                </div>
              );
            },
          )}
          <div className="">
            <div>
              <div className="flex"></div>
              <div className="my-2">
                <ResponseDetailsComponentNew
                  item={detailsData?.getPreAuthTransaction?.data}
                />
              </div>
            </div>
          </div>

          <Box className="my-3">
            <Typography
              className="flex gap-3 !font-bold mb-2 !text-[18px]"
              variant="h6"
              sx={{ width: "50%", flexShrink: 0 }}
            >
              Items
            </Typography>
            <ItemsTable data={detailsData} />
          </Box>
          <Box className="my-3">
            <Typography
              className="flex gap-3 !font-bold mb-2 !text-[18px]"
              variant="h6"
              sx={{ width: "50%", flexShrink: 0 }}
            >
              Diagnosis
            </Typography>
            <DiagnosisTable data={detailsData?.getPreAuthTransaction} />
          </Box>
          <Box className="my-3 ">
            <Typography
              className="flex gap-3 !font-bold mb-2 !text-[18px]"
              variant="h6"
              sx={{ width: "50%", flexShrink: 0 }}
            >
              Care Teams
            </Typography>
            <CareTeamsTable data={detailsData?.getPreAuthTransaction} />
          </Box>
          <Box className="my-3">
            <Typography
              className="flex gap-3 !font-bold mb-2 !text-[18px]"
              variant="h6"
              sx={{ width: "50%", flexShrink: 0 }}
            >
              Supporting Info
            </Typography>
            <SupportingInfoTable data={detailsData?.getPreAuthTransaction} />
          </Box>
        </>
      )}
      {currentTab == "json" && (
        <div className="preauth-form  !mt-3">
          <div>
            <JsonTable item={detailsData} />
          </div>
        </div>
      )}
      {currentTab == "communications" && (
        <>
          <CommunicationDetails currentItem={currentItem} item={detailsData} />
        </>
      )}
      {currentTab == "encounter" && (
        <>
          <Encounter
            item={detailsData?.getPreAuthTransaction?.data?.encounter}
          />
        </>
      )}
      {currentTab == "visionPrescription" && (
        <>
          <VisionPrescription item={detailsData?.getPreAuthTransaction?.data} />
        </>
      )}
      {currentTab == "accident" && (
        <>
          <AccidentInfo item={detailsData?.getPreAuthTransaction?.data} />
        </>
      )}

      {currentTab == "rejectReason" && (
        <>
          <ItemRejectReason item={detailsData?.getPreAuthTransaction?.data} />
        </>
      )}

      <UcafForm
        item={detailsData?.getPreAuthTransaction?.data}
        showUCAF={showUCAF}
        setShowUCAF={setShowUCAF}
      />
      <DcafForm
        item={detailsData?.getPreAuthTransaction?.data}
        showDCAF={showDCAF}
        setShowDCAF={setShowDCAF}
      />
      {/* <AppModal isOpen={loadingDetail || loadingSupportingInfo} /> */}
    </div>
  );
};

export default PreAuthDetailComponent;
